import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import RegisterInterestForm from '../../../WaitlistPage/RegisterInterestForm';

import css from './SectionNotifyMe.module.css';

// Anchor id so other surfaces can link straight to the band ('/#notify-me').
export const NOTIFY_ME_ANCHOR = 'notify-me';

/**
 * Signed-out homepage notify-me band: the existing register-interest form (same /api/register-interest
 * endpoint and lead table as the /waitlist page) for visitors outside the launch area.
 *
 * @returns {JSX.Element}
 */
const SectionNotifyMe = () => (
  <section className={css.root} id={NOTIFY_ME_ANCHOR}>
    <div className={css.inner}>
      <div className={css.copy}>
        <h2 className={css.title}>
          <FormattedMessage id="LandingPage.notifyMe.title" />
        </h2>
        <p className={css.body}>
          <FormattedMessage id="LandingPage.notifyMe.body" />
        </p>
      </div>
      <div className={css.formCard}>
        <RegisterInterestForm />
      </div>
    </div>
  </section>
);

export default SectionNotifyMe;
